<template>
    <v-app :lang="$i18n.locale">
        <v-container class="spacing-playground form-margin-top">
            <v-btn @click="download">{{$t('message.common.download')}}</v-btn>
            <VueHtml2pdf
                :show-layout="true"
                :float-layout="true"
                :manual-pagination="false"
                :preview-modal="true"
                :enable-download="true"
                :pdf-quality="2"
                pdf-orientation="landscape"
                ref="DownloadComp"
                pdf-format="a4"
                pdf-content-width="595pt"
            >
                <section slot="pdf-content">
                    <TicketPart />
                </section>
            </VueHtml2pdf>
        </v-container>
    </v-app>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import TicketPart from "@/components/fileElement/TicketPart";

export default {
    name: "TicketForm",
    data: () => ({}),
    methods: {
        download() {
            this.$refs.DownloadComp.generatePdf();
        },
    },
    components: { VueHtml2pdf, TicketPart },
};
</script>
